export default {
  updateRestaurantServiceStaus: 'UPDATE_RESTAURANT_SERVICE_STATUS',
  updateRestaurantServiceStausSuccess:
    'UPDATE_RESTAURANT_SERVICE_STATUS_SUCCESS',
  updateRestaurantServiceStausFailed: 'UPDATE_RESTAURANT_SERVICE_STATUS_FAILED'
};
